import * as React from 'react';
import { Select2WithAndSeparator } from '../researchFilter/select2Component';

export default class Select2 extends Select2WithAndSeparator {
    showOrSeparators() {
    } 
}
